<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <!-- Page Content -->
    <div class="content container-fluid">
      <!-- Page Header -->
      <employees-header :title="title" :path="path" :text="text" :text1="text1" />
      <!-- /Page Header -->

      <!-- Search Filter -->
      <search-filter :initialStatus="currentStatus" @searchClicked="searchClicked"></search-filter>
      <!-- /Search Filter -->

      <div class="row">
        <div class="col-md-12">
          <div class="showentries mb-3 custom-select">
            <div class="d-flex align-items-center gap-2"><span>Show</span>
              <select v-model="perPage" @change="current = 1; getUsers()" style="outline: none">
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
              <span>entries</span>
            </div>
          </div>
          <div v-if="!loader">
            <div class="table-responsive">

              <a-table class="stripped table-hover" :columns="columns" :data-source="usersData" :pagination="false"
                v-if="usersData.length" :scroll="{ x: 'max-content' }">
                <template #bodyCell="{ column, record }">
                  <template v-if="column.key === 'name'">
                    <h2 class="table-avatar">
                      <a href="javascript:;" class="avatar" @click="openImagePreview(record)">
                        <img :src="getImage(record.profile_image_path)" alt="User Image"
                          v-if="record.profile_image_path" />
                        <img src="../../../assets/img/avatar/avatar-29.png" alt="User Image" v-else />
                      </a>
                      <div class="text-end dropdown-container">
                          <action-dropdown @banked-time="bankedTimeClicked"
                            variant="text"
                            :employee="record"
                            :showViewProfile="true"
                            :monitoringText="{ monitor: 'Start Monitoring', monitored: 'Stop Monitoring' }"
                            :reportAsEvent="true"
                            @edit="editClicked"
                            @leaves="leavesClicked"
                            @attendance="attendanceClicked"
                            @sick-leave="sickLeaveClicked"
                            @toggle-monitoring="monitorClicked"
                            @add-face-template="addFaceTemplateClicked"
                            @face-templates="faceTemplatesClicked"
                            @report="viewReport"
                            @reset-password="resetPasswordClicked"
                            @assign-employee="assignEmployeeClicked"
                            @deactivate="deactivateClicked"
                            @activate="activateClicked"
                            @cancel-deactivation="cancelDeactivationClicked"
                          />
                          <div v-if="record.scheduled_deactivation_date" class="mt-1">
                            <span class="badge bg-soft-warning text-warning" style="font-size: 11px;">
                              <i class="fa-solid fa-clock me-1"></i> Scheduled: {{ record.scheduled_deactivation_date }}
                            </span>
                          </div>
                      </div>
                    </h2>
                  </template>
                  <template v-else-if="column.key === 'locations'">
                    <span v-for="(item, index) in record.locations" :key="index" class="inline-item">
                      <span v-if="index > 0">,</span>{{ item.name }}
                    </span>
                  </template>
                  <template v-else-if="column.key === 'joining_date'">
                    {{ formatDate(record.joining_date) }}
                  </template>
                  <template v-else-if="column.key === 'deactivated_at'">
                    {{ formatDate(record.deactivated_at || record.deactivation_date) }}
                  </template>
                  <template v-else-if="column.key === 'Role'">
                    <!-- <div class="dropdown">
                    <a href="javascript:;" class="btn btn-white btn-sm btn-rounded dropdown-toggle"
                      data-bs-toggle="dropdown" aria-expanded="false">Web Developer
                    </a>
                    <div class="dropdown-menu">
                      <a class="dropdown-item" href="javascript:;">Software Engineer</a>
                      <a class="dropdown-item" href="javascript:;">Software Tester</a>
                      <a class="dropdown-item" href="javascript:;">Frontend Developer</a>
                      <a class="dropdown-item" href="javascript:;">UI/UX Developer</a>
                    </div>
                  </div> -->
                    {{ companyIdToCompanyRole(record.company_role_id) }}
                  </template>
                  <!-- <template v-else-if="column.key === 'action'">
                    <div class="text-end">
                      <div class="dropdown dropdown-action">
                        <a href="javascript:;" class="action-icon dropdown-toggle" data-bs-toggle="dropdown"
                          aria-expanded="false"><i class="material-icons">more_vert</i></a>
                        <div class="dropdown-menu dropdown-menu-right">
                          <a class="dropdown-item" href="javascript:;" data-bs-toggle="modal"
                            data-bs-target="#edit_employee" @click="editClicked(record)"><i
                              class="fa-solid fa-pencil m-r-5"></i> Edit</a>
                          <a class="dropdown-item" href="javascript:;" @click="leavesClicked(record)"><i
                              class="fa-solid fa-arrow-left m-r-5"></i> Leaves</a>
                          <a class="dropdown-item" href="javascript:;" @click="attendanceClicked(record)"><i
                              class="fa fa-calendar m-r-5"></i> Attendance</a>
                          <a class="dropdown-item" href="javascript:;" data-bs-toggle="modal"
                            data-bs-target="#sick_leave" @click="sickLeaveClicked(record)"><i
                              class="fa fa-right-from-bracket m-r-5"></i>Sick Leave</a>
                          <a class="dropdown-item" href="javascript:;" @click="monitorClicked(record)"><i
                              class="fa fa-street-view m-r-5"></i>{{ record.is_monitored ? 'Monitered' : 'Monitor' }}</a>
                          <a class="dropdown-item" href="javascript:;" data-bs-toggle="modal"
                            data-bs-target="#face_template" @click="addFaceTemplateClicked(record)"><i
                              class="fa-solid fa-plus m-r-5"></i>Add Face Template</a>
                          <router-link class="dropdown-item"
                            :to="{ name: 'employeeReport', params: { id: record.id } }"><i
                              class="fa fa-th m-r-5"></i>Employee Report</router-link>
                          <a class="dropdown-item" href="javascript:;" data-bs-toggle="modal"
                          data-bs-target="#delete_employee"><i class="fa-regular fa-trash-can m-r-5"></i> Delete</a>
                        </div>
                      </div>
                    </div>
                  </template> -->
                </template>
              </a-table>
              <div v-else>
                <div class="card text-center">
                  <div class="card-body">
                    <img src="../../../assets/img/avatar/no-data.png" alt="no-data" srcset="" class="responsive-img">
                    <p>No employee have been added.</p>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-center">
                <a-pagination v-model:current="current" v-model:pageSize="perPage" :total="total" @change="getUsers"
                  show-less-items class="mt-3 " :showSizeChanger="false">
                  <template #itemRender="{ type, originalElement }">
                    <a v-if="type === 'prev'">Previous</a>
                    <a v-else-if="type === 'next'">Next</a>
                    <component :is="originalElement" v-else></component>
                  </template>
                </a-pagination>
              </div>
            </div>

          </div>
          <div class="d-flex justify-content-center text-center mt-5" v-else>
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Content -->

    <employee-modal @userAdded="getUsers"></employee-modal>
    <edit-employee-modal ref="editEmployee" @editedUser="getUsers"></edit-employee-modal>
    <add-face-template-modal ref="addface"></add-face-template-modal>
    <face-templates-modal ref="faceTemplates"></face-templates-modal>
    <sick-leave-modal ref="sickLeave"></sick-leave-modal>
    <leaves-admin-modal ref="leaveAdmin" @allLeaves="getUsers"></leaves-admin-modal>
    <sick-leave-details-modal ref="sickLeaveDetails"></sick-leave-details-modal>
    <employee-report-modal ref="employeeReportModal"></employee-report-modal>
    <reset-password-modal ref="resetPasswordModal"></reset-password-modal>
    <assign-employee-modal ref="assignEmployeeModal" @updated="getUsers"></assign-employee-modal>
    <deactivate-employee-modal ref="deactivateEmployeeModal" @deactivated="getUsers"></deactivate-employee-modal>

    <!-- Image Preview Modal -->
    <div class="modal fade" id="image_preview_modal" tabindex="-1" aria-labelledby="imagePreviewLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="imagePreviewLabel">{{ selectedEmployeeName }}</h5>
            <button type="button" class="btn-close close-btn" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <img :src="selectedImageUrl" alt="Employee Image" class="img-fluid preview-image" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Page Wrapper -->
    <view-banked-time-details-modal ref="viewBankedTimeDetails"></view-banked-time-details-modal>
</template>

<script>
import axios from 'axios';
import { Modal } from 'bootstrap';
import { getImage, formatDateTimeStandardShort } from "@/utils/util-funcitons";
import { VUE_APP_API_BASE_URL } from "../../../config";
import ActionDropdown from "@/components/action-dropdown.vue";
import FaceTemplatesModal from "@/components/modal/face-templates-modal.vue";
import AssignEmployeeModal from "@/components/modal/assign-employee-modal.vue";
import DeactivateEmployeeModal from "@/components/modal/deactivate-employee-modal.vue";
import { monitorMixin } from "@/mixins/monitorMixin";
import { dateRangeStart, dateRangeEnd } from '@/utils/util-var';
const data = [
  {
    Image: "avatar-02.jpg",
    Name: "John Doe",
    Title: "Web Designer",
    EmployeeID: "FT-0001",
    Email: "johndoe@example.com",
    Mobile: "9876543210",
    JoinDate: "1 Jan 2023",
  },
  {
    Image: "avatar-09.jpg",
    Name: "Richard Miles",
    Title: "Web Designer",
    EmployeeID: "FT-0002",
    Email: "richardmiles@example.com",
    Mobile: "9876543210",
    JoinDate: "18 Mar 2023",
  },
  {
    Image: "avatar-10.jpg",
    Name: "John Smith",
    Title: "Web Designer",
    EmployeeID: "FT-0003",
    Email: "Android Developer",
    Mobile: "9876543210",
    JoinDate: "1 Apr 2023",
  },
  {
    Image: "avatar-05.jpg",
    Name: "Mike Litorus",
    Title: "IOS Developer",
    EmployeeID: "FT-0004",
    Email: "mikelitorus@example.com",
    Mobile: "9876543210",
    JoinDate: "1 Apr 2023",
  },
  {
    Image: "avatar-11.jpg",
    Name: "Wilmer Deluna",
    Title: "Team Leader",
    EmployeeID: "FT-0005",
    Email: "wilmerdeluna@example.com",
    Mobile: "9876543210",
    JoinDate: "22 May 2023",
  },
  {
    Image: "avatar-12.jpg",
    Name: "Jeffrey Warden",
    Title: "Web Developer",
    EmployeeID: "FT-0006",
    Email: "jeffreywarden@example.com",
    Mobile: "9876543210",
    JoinDate: "16 Jun 2023",
  },
  {
    Image: "avatar-13.jpg",
    Name: "Bernardo Galaviz",
    Title: " Web Developer",
    EmployeeID: "FT-0007",
    Email: "bernardogalaviz@example.com",
    Mobile: "9876543210",
    JoinDate: "1 Jan 2023",
  },
];
export default {
  mixins: [monitorMixin],
  components: {
    ActionDropdown,
    FaceTemplatesModal,
    AssignEmployeeModal,
    DeactivateEmployeeModal
  },
  computed: {
    columns() {
      const baseColumns = [
        {
          title: "Name",
          dataIndex: "name",
          key: "name",
          sorter: {
            compare: (a, b) => {
              const nameA = (a.name || "").toLowerCase();
              const nameB = (b.name || "").toLowerCase();
              return nameA > nameB ? -1 : nameB > nameA ? 1 : 0;
            },
          },
        },
        {
          title: "Employee ID",
          dataIndex: "employee_code",
          key: "employee_code",
          sorter: {
            compare: (a, b) => {
              const numA = Number(a.employee_code);
              const numB = Number(b.employee_code);
              return numA > numB ? -1 : numA < numB ? 1 : 0;
            },
          },
        },
        {
          title: "Location",
          dataIndex: "locations",
          key: "locations",
        },
        {
          title: "Email",
          dataIndex: "email",
          key: "email",
        },
        {
          title: "Join Date",
          dataIndex: "joining_date",
          key: "joining_date",
          sorter: {
            compare: (a, b) => {
              const timeA = a.joining_date ? new Date(a.joining_date).getTime() : 0;
              const timeB = b.joining_date ? new Date(b.joining_date).getTime() : 0;
              return timeA > timeB ? -1 : timeA < timeB ? 1 : 0;
            },
          },
        },
      ];

      if (this.currentStatus === 'inactive' || this.usersData.some(u => !!(u && (u.deactivated_at || u.deactivation_date)))) {
        baseColumns.push({
          title: "Deactivated Date",
          dataIndex: "deactivated_at",
          key: "deactivated_at",
          sorter: {
            compare: (a, b) => {
              const timeA = (a.deactivated_at || a.deactivation_date) ? new Date(a.deactivated_at || a.deactivation_date).getTime() : 0;
              const timeB = (b.deactivated_at || b.deactivation_date) ? new Date(b.deactivated_at || b.deactivation_date).getTime() : 0;
              return timeA > timeB ? -1 : timeA < timeB ? 1 : 0;
            },
          },
        });
      }

      baseColumns.push({
        title: "Role",
        dataIndex: "Role",
        key: "Role",
      });

      return baseColumns;
    },
  },
  data() {
    return {
      data,
      title: "Employees List",
      path: "Dashboard",
      text: "Employees List",
      text1: "Add Employee",
      usersData: [],
      perPage: 10,
      current: 1,
      total: 0,
      employee_name: "",
      location_id: null,
      company_role_id: null,
      companyId: [],
      loader: false,
      selectedImageUrl: "",
      selectedEmployeeName: "",
      startDate: dateRangeStart,
      endDate: dateRangeEnd,
      currentStatus: "active"
    };
  },
  mounted() {
    this.getUsers(),
      this.getCompanyRoles()
  },

  methods: {
    bankedTimeClicked(record) {
      if(this.$refs.viewBankedTimeDetails) {
        this.$refs.viewBankedTimeDetails.updateValues(record, {});
      }
    },

    searchClicked(data) {
      this.employee_name = data.employee_name;
      this.location_id = data.location_id;
      this.company_role_id = data.company_role_id;
      this.currentStatus = data.status || '';
      this.current = 1;
      this.getUsers();
    },
    getImage,
    getUsers() {
      this.loader = true;
      if (Number(this.perPage) >= this.total) {
        this.current = 1
      }
      const params = {
        per_page: this.perPage,
        employee_name: this.employee_name,
        location_id: this.location_id,
        company_role_id: this.company_role_id,
        status: this.currentStatus
      }
      axios.get(`${VUE_APP_API_BASE_URL}/user/list?page=${this.current}`, { params: params })
        .then((response) => {

          if (response.data.status) {
            this.usersData = response.data.data.data;
            this.current = response.data.data.current_page;

            this.total = response.data.data.total;

            this.usersData.forEach(element => {
              element["name"] = element["first_name"] + " " + element["last_name"];
            });
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        })
        .finally(() => {
          this.loader = false;
        });
    },

    deactivateClicked(employee) {
      this.$refs.deactivateEmployeeModal.updateValues(employee);
      const modal = new Modal(document.getElementById('deactivate_employee_modal'));
      modal.show();
    },

    cancelDeactivationClicked(employee) {
      if (confirm(`Are you sure you want to cancel the scheduled deactivation for ${employee.name}?`)) {
        axios.post(`${VUE_APP_API_BASE_URL}/user/${employee.id}/cancel-deactivation`)
          .then((response) => {
            if (response.data.status) {
              this.$toast.success(response.data.message || 'Scheduled deactivation cancelled successfully');
              this.getUsers();
            } else {
              this.$toast.error(response.data.message || 'Action failed');
            }
          })
          .catch((error) => {
            this.$toast.error(error.response?.data?.message || 'Something went wrong');
          });
      }
    },

    activateClicked(employee) {
      if (confirm(`Are you sure you want to activate ${employee.name}?`)) {
        axios.post(`${VUE_APP_API_BASE_URL}/user/${employee.id}/activate`)
          .then((response) => {
            if (response.data.status) {
              this.$toast.success(response.data.message || 'User activated successfully');
              this.getUsers();
            } else {
              this.$toast.error(response.data.message || 'Activation failed');
            }
          })
          .catch((error) => {
            this.$toast.error(error.response?.data?.message || 'Something went wrong');
          });
      }
    },

    formatDate(dateString) {
      if (!dateString) return '-';
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return '-';
      // Then specify how you want your dates to be formatted
      return formatDateTimeStandardShort(date);
    },

    companyIdToCompanyRole(id) {
      const company = this.companyId.find(item => item.id === id);
      return company ? company.name : null;
    },

    async getCompanyRoles() {
      await axios.get(`${VUE_APP_API_BASE_URL}/company-role/get`)
        .then((response) => {
          if (response.data.status) {
            this.companyId = response.data.data;
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        }).catch(function (error) {
          console.log(error);
        });
    },

    editClicked(record) {
      this.$refs.editEmployee.updateValues(record);
    },
    sickLeaveClicked(record) {
      this.$refs.sickLeave.updateValues(record);
    },

    leavesClicked(record) {
      const routeData = this.$router.resolve({ path: '/employee/leaves-employee', query: { id: record.id } });
      window.open(routeData.href, '_blank');
    },

    attendanceClicked(record) {
      const routeData = this.$router.resolve({ path: '/employee/attendance-employee', query: { id: record.id } });
      window.open(routeData.href, '_blank');
    },
    addFaceTemplateClicked(record) {
      this.$refs.addface.updateValues(record);
    },
    faceTemplatesClicked(employee) {
      this.$refs.faceTemplates.showTemplates(employee);
    },

    openImagePreview(record) {
      if (record.profile_image_path) {
        this.selectedImageUrl = this.getImage(record.profile_image_path);
      } else {
        this.selectedImageUrl = require('../../../assets/img/avatar/avatar-29.png');
      }
      this.selectedEmployeeName = record.name;
      const modal = new Modal(document.getElementById('image_preview_modal'));
      modal.show();
    },

    viewReport(record) {
      this.$refs.employeeReportModal.updateValues(record.id, this.startDate, this.endDate);
      const modal = new Modal(document.getElementById('employee_report_modal'));
      modal.show();
    },
    resetPasswordClicked(record) {
      this.$refs.resetPasswordModal.updateValues(record);
    },
    assignEmployeeClicked(record) {
      this.$refs.assignEmployeeModal.updateValues(record);
    },

  }
};
</script>
<style scoped>
:where(.css-dev-only-do-not-override-1hsjdkk).ant-pagination .ant-pagination-prev,
:where(.css-dev-only-do-not-override-1hsjdkk).ant-pagination .ant-pagination-next {
  background-color: #ffffff00 !important;
}

.inline-item {
  display: inline-block;
  margin-right: 2px;
  /* Adjust spacing between items */
}



:deep(.ant-table),
:deep(.ant-table-container),
:deep(.ant-table-content),
:deep(.ant-table-body) {
  overflow: visible !important;
}

.responsive-img {
  width: 100%;
  max-width: 100px;
  height: auto;
}

.custom-select select {
  appearance: none;
  width: 50px;
  font-size: 14px;
  padding: 2px 5px;
  background-color: #fff;
  border: 1px solid #caced1;
  border-radius: 0.25rem;
  color: #000;
  cursor: pointer;
}

.avatar {
  cursor: pointer;
}

.avatar:hover {
  opacity: 0.8;
}

.preview-image {
  max-height: 70vh;
  object-fit: contain;
  border-radius: 8px;
}

.close-btn {
  background-color: #A6A8A9;
  height: 20px;
  width: 20px;
  border: 1px solid #A6A8A9;
  font-size: 20px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.close-btn:hover {
  background-color: #099bf8;
  color: #ffffff;
  border-color: #099bf8;
}

.close-btn:hover span {
  color: #FFF;
}

.close-btn span {
  color: #373B3E;
}
</style>
